export default "__VITE_ASSET__6072aa1f__"